import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import moment from 'moment';
import { BsPlayCircle } from "react-icons/bs";

import checkCompanyInfo from "utils/checkCompanyInfo";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import Maybe from "components/__new/common/Maybe";
import SelectInput from "components/__new/common/form/SelectInput"
import FundAccount from "components/__new/payments/FundAccount";
import * as dashboardActions from "store/entities/dashboard/action";
import * as employeesAction from "store/entities/employees/action";
import * as infoActions from "store/entities/settingsInfo/action";
import * as withdrawalsAction from "store/entities/withdrawals/action";
import * as notificationActions from "store/entities/notification/action";
import * as walletAction from "store/entities/wallet/action";
import useLoginInfo from 'hooks/useLoginInfo';
import { ReactComponent as IconArrowRight } from "assets/images/icons/project-icons/arrow-right.svg";
import useDashboardMetrics from 'hooks/useDashboardMetrics';
import CurrencyFormat from "utils/currencyFormat";
import ContentLoading from "components/__new/common/ContentLoading";
import useEmployerProducts from 'hooks/useEmployerProducts';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as ArrowUp } from "assets/images/icons/arrow-up.svg";
import { ReactComponent as ArrowDown } from "assets/images/icons/icon-arrow-down-red.svg";
import { ReactComponent as CashPayment } from "assets/images/icons/CashPayment.svg";
import Spinner from 'components/__new/common/Spinner';
import { ReactComponent as CloseBanner } from "assets/images/icons/close-banner.svg";
import { ReactComponent as IconPlus } from "assets/images/icons/plus.svg";
import { ReactComponent as IconSend } from "assets/images/icons/send-2-new.svg";
import { ReactComponent as IconYieldChart } from "assets/images/icons/project-icons/yield-chart.svg";
import { ReactComponent as IconInflow } from "assets/images/icons/inflow.svg";
import { ReactComponent as IconOutflow } from "assets/images/icons/outflow.svg";
import IconDashboardBannerDesktop from 'assets/images/icons/project-icons/desktop-yield.png';
import IconDashboardBannerTablet from 'assets/images/icons/project-icons/tab-yield.png';
import IconDashboardBannerMobile from 'assets/images/icons/project-icons/mobile-yield.png';
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import { ReactComponent as DebitIcon } from "assets/images/icons/debitIcon.svg";
import { ReactComponent as CreditIcon } from "assets/images/icons/creditIcon.svg";
import InflowOutflowChart from 'components/__new/dashboardCharts/InflowOutflowChart';
import HowYouSpentChart from 'components/__new/dashboardCharts/HowYouSpentChart';
import MonthlyBalanceGraph from 'components/__new/dashboardCharts/MonthlyBalanceGraph';
import OnDemandPayEmployeesChart from 'components/__new/dashboardCharts/OnDemandPayEmployeesChart';
import { verifyFundBusinessAccountStatus } from 'store/entities/wallet/action';
import { getLastXMonths } from 'utils/getLastXMonths';
import useUrlNavigation from 'hooks/useUrlNavigation';
import { DateTimeFormat } from 'utils/dateFormat';
import useSubAccounts from "hooks/useSubAccounts";
import { useMediaQuery } from 'hooks/useMediaQuery';
import { ReactComponent as CloseOutIcon } from "assets/images/icons/x-white.svg"
import { capitalizeFirstLetter } from 'utils/stringFormatter';



const Dashboard = () => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const {urlQueryParams} = useUrlQueryParams();
    const {urlQuery} = useUrlNavigation();
    const history = useHistory();
    const location = useLocation();
    const isMobile = useMediaQuery('(max-width: 768px)');
    const isTablet = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');
    const isDesktop = useMediaQuery('(min-width: 1025px)');
    const { isOnDemandUser, isBulkPayUser, isPayrollUser } = useEmployerProducts();
    const { companyInfo } = useSelector((s) => s.entities.settingsInfo);
    const { dashboardLoading, dashboard, isFiltering } = useSelector((s) => s.entities.dashboard);
    const { dashboardLoading: walletDashboardLoading, dashboard: walletDashboard, yieldBalance, yieldBalanceLoading } = useSelector((s) => s.entities.wallet);
    const { currentYear, previousMonth, previousMonthStart, currentMonthStart } = useDashboardMetrics()  
    const {
        subAccountsLoading, subAccounts, getSubAccounts,
        isOpenModalSwitchAccount, setIsOpenModalSwitchAccount,
        switchToSubAccount, switchToMainAccount, subAccountSwitchAccount
    } = useSubAccounts();

    // eslint-disable-next-line
    const [isCompanyInfoFilled, setIsCompanyInfoFilled] = useState(true);
    const [isAdBannerOpen, setIsAdBannerOpen] = useState(true);
    const [greeting, setGreeting] = useState("");
    const [currentTime, setCurrentTime] = useState(moment());
    const [isOpenFundAccount, setIsOpenFundAccount] = useState(false);
    const [employeeStatsData, setEmployeeStatsData] = useState([]);
    const [listParams, setListParams] = useState({
        "month": "",
        "year": "",
    });
    const [dashboardListParams, setDashboardListParams] = useState({
        walletFilter: "",
        cashflowFilter: "",
        expencesFilter: "",
    });
    const [selectedMonthFilter, setSelectedMonthFilter] = useState("last6months");
    const [filteringWalletData, setFilteringWalletData] = useState(false);
    const [selectedInflowOutflowFilter, setSelectedInflowOutflowFilter] = useState("last6months");
    const [filteringInflowOutflowData, setFilteringInflowOutflowData] = useState(false);
    const [selectedExpenseFilter, setSelectedExpenseFilter] = useState("last6months");
    const [filteringExpenseData, setFilteringExpenseData] = useState(false);
    
    const handleCloseAdBanner = () => {
        setIsAdBannerOpen(false)
    }

    const getWithdrawalsMetrics = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "month", "string", "", "month");
        params = processParams(urlQueryParams, params, "year", "string", "", "year");

        setListParams(params);
        dispatch(withdrawalsAction.getWithdrawalsMetrics(params));
    }
        
    // const getDashboardData = () => {
    //     dispatch(dashboardActions.getDashboard());
    // }
    
    const filterDashboardData = () => {
        let params = {...dashboardListParams};
        
        params = processParams(urlQueryParams, params, "walletFilter", "string", "", "wallet_filter");
        params = processParams(urlQueryParams, params, "cashflowFilter", "string", "", "cashflow_filter");
        params = processParams(urlQueryParams, params, "expencesFilter", "string", "", "expences_filter");

        setDashboardListParams(params);
        dispatch(dashboardActions.filterDashboard(params));
    }
    
    const handleSelectedMonthFilterChange = (evt) => {
        const { value } = evt.target;
        history.push(urlQuery("walletFilter" + "=" + value));
        setSelectedMonthFilter(value);
        setFilteringWalletData(true);
    }
    
    const handleSelectedInflowOutflowChange = (evt) => {
        const { value } = evt.target;
        history.push(urlQuery("cashflowFilter" + "=" + value));
        setSelectedInflowOutflowFilter(value);
        setFilteringInflowOutflowData(true);
    }
    
    const handleSelectedExpensesChange = (evt) => {
        const { value } = evt.target;
        history.push(urlQuery("expencesFilter" + "=" + value));
        setSelectedExpenseFilter(value);
        setFilteringExpenseData(true);
    }
    
    const getYieldSettings = () => {
        dispatch(walletAction.getYieldSettings());
        dispatch(walletAction.getYieldBalance());
    }

    useEffect(() => {
        getYieldSettings();
    }, [])

    useEffect(() => {
        if (!isFiltering && filteringWalletData) {
            setFilteringWalletData(false);
        }
        
        if (!isFiltering && filteringInflowOutflowData) {
            setFilteringInflowOutflowData(false);
        }
        
        if (!isFiltering && filteringExpenseData) {
            setFilteringExpenseData(false);
        }
    }, [isFiltering])
    
    useEffect(() => {
        if (Object.entries(urlQueryParams).length > 0) {
            setSelectedMonthFilter(urlQueryParams?.walletFilter || "last6months");
            setSelectedInflowOutflowFilter(urlQueryParams?.cashflowFilter || "last6months");
            setSelectedExpenseFilter(urlQueryParams?.expencesFilter || "last6months");
        }
    }, [urlQueryParams])
    
    useEffect(() => {
        filterDashboardData();
    }, [location]);

    useEffect(() => {
        dispatch(notificationActions.getAllNotifications());
        dispatch(dashboardActions.getBulkPayMetrics(userInfo?.token));
        dispatch(dashboardActions.getBulkPayAggregates(userInfo?.employer?._id));
        dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));

        if(isOnDemandUser) {
            dispatch(employeesAction.getEmployeeMetrics());
            dispatch(employeesAction.getPreviousMonthEmployeeMetrics({from: previousMonthStart, to: currentMonthStart}));
            getWithdrawalsMetrics();
            dispatch(withdrawalsAction.getPrevMonthWithdrawalsData({month: previousMonth, year: currentYear}));
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (companyInfo?.status === "success"){
            const companyInfoFilled = checkCompanyInfo(companyInfo, "existing employer");
            setIsCompanyInfoFilled(companyInfoFilled);
        }
        // eslint-disable-next-line
    }, [companyInfo]);

    useEffect(() => {
        if (dashboard?.status === "success"){
            let monthsGraph = dashboard?.dashboard?.monthsGraph;
            if (monthsGraph){
                const length = Object.keys(monthsGraph).length;
                let data = [];
                for (let i = 1; i <= length; i++){
                    data.push(monthsGraph[i]);
                }
                setEmployeeStatsData(data);
            }
        }
        // eslint-disable-next-line
    }, [dashboard]);
    
    

    // Greeting based on current time and day
    useEffect(() => {
        const intervalID = setInterval(() => {
            // Update current time every minute
            setCurrentTime(moment());
            updateGreeting();
          }, 60000);

        const updateGreeting = () => {
            const currentTime = new Date();
            const currentHour = currentTime.getHours();

            let newGreeting = "";

            if (currentHour < 12) {
                newGreeting = "Good morning";
            } else if (currentHour < 17) {
                newGreeting = "Good afternoon";
            } else {
                newGreeting = "Good evening";
            }

            setGreeting(newGreeting);
        };

        updateGreeting();

        // Clean up interval
        return () => clearInterval(intervalID);
    }, [])

    return (
        <div className='dashboard-container'>

            <DynamicHeadTag
                headerText="Overview"
                headerDescription="Access and manage all your finance and people operations activities in one place"
            />

            <FundAccount
                isOpen={isOpenFundAccount}
                setIsOpen={setIsOpenFundAccount}
                dashboardLoading={walletDashboardLoading}
                dashboard={walletDashboard}
            />

            <div className='flex justify-between items-center'>
                <div>
                {!dashboardLoading &&
                    <div className='lg:text-3xl text-lg font-medium mb-2'>
                        {`${greeting}, ${capitalizeFirstLetter(dashboard?.member?.firstName)}`} 
                    </div> 
                }
                    <div className='text-sm text-ep-gray-500'>{currentTime.format('MMM DD, YYYY • hh:mm a')}</div>
                </div>
                
                {/* <div className='flex items-center text-ep-primary-600 cursor-pointer'>
                    <span className='mr-2'><StarShineIcon /></span>
                    <span>Customize Dashboard</span>
                </div> */}
            </div>

            <ComplianceNotification />

            <div className='bg-ep-white rounded-2xl my-5 p-5'>
                <div className='flex flex-col lg:flex-row gap-6'>
                    <div className='w-full lg:w-2/6 lg:pr-6 lg:border-r lg:border-ep-gray-800 dashboard-bal-wrapper'>
                        <div className='text-ep-gray-700 text-lg font-normal'>Total Balance</div>
                        <div className='font-bold text-3xl dashboard-total-bal'>
                            <ContentLoading
                                loading={dashboardLoading}
                                data={<>
                                    {CurrencyFormat(dashboard?.totalWalletBalance / 100 || 0, true)}
                                </>}
                            />
                        </div>
                            <ContentLoading
                                loading={dashboardLoading}
                                data={
                                    <>
                                        {
                                            dashboard?.percentageIncrease?.status === "+" ? (
                                                <div className='my-2 bg-ep-light-success rounded-xl px-5 py-1 text-ep-success inline-flex items-center'>
                                                    <span className='mr-2'><ArrowUp/></span>
                                                    {dashboard?.percentageIncrease?.status}{dashboard?.percentageIncrease?.percentage}% {dashboard?.percentageIncrease?.status === "+" ? "more than" : "less than"} last month
                                                </div>
                                            ) : (
                                                <div className='my-2 bg-[#FEF3F2] rounded-xl px-5 py-1 text-[#B42318] inline-flex items-center'>
                                                    <span className='mr-2'><ArrowDown/></span>
                                                    {dashboard?.percentageIncrease?.status}{dashboard?.percentageIncrease?.percentage}% {dashboard?.percentageIncrease?.status === "+" ? "more than" : "less than"} last month
                                                </div>
                                            )
                                        }
                                    </>
                                }
                            />

                        <div className='flex flex-wrap sm:flex-nowrap'>
                            <button type="button" onClick={() => setIsOpenFundAccount(true)} className="btn btn-lg !px-5 mt-3 mr-3 xl:btn-block whitespace-nowrap text-white bg-ep-primary-600">
                                <IconPlus className="mr-2" />
                                Fund
                            </button>
                            <Link to="/payments/transfers/instant-transfers" className="btn btn-lg text-[#193F52] font-medium !px-5 mt-3 xl:btn-block whitespace-nowrap bg-ep-primary-600 bg-opacity-10">
                                <IconSend className="mr-2" />
                                Transfer
                            </Link>
                        </div>
                    </div>
                    <div className='w-full lg:w-4/6 dashboard-chart-wrapper'>{/* flex-1 */}
                        <div className="flex justify-end">
                            <SelectInput onChange={handleSelectedMonthFilterChange} value={selectedMonthFilter}>
                                <option value="" disabled>Select</option>
                                <option value="last6months">Last 6 Months</option>
                                <option value="last3months">Last 3 Months</option>
                            </SelectInput>
                        </div>
                        <Maybe condition={!filteringWalletData && dashboard?.walletDataChat?.length > 0}>
                            <MonthlyBalanceGraph
                                chartData={dashboard?.walletDataChat}
                            />
                        </Maybe>
                        <Maybe condition={filteringWalletData}>
                            <Spinner spinnerTableInfoClassNameReplace="p-0" />
                        </Maybe>
                        <Maybe condition={dashboard?.walletDataChat?.length === 0}>
                            <div className='text-center text-[#4A5564] border rounded-xl p-3'>
                                <div className='my-2'>No Data Available Yet.</div>
                                <div className='my-2'>Your data will appear here once you complete a transaction.</div>
                            </div>
                        </Maybe>
                    </div>
                </div>
            </div>

            {/* <DashboardBanner/> */}
            <Maybe condition={isDesktop && isAdBannerOpen}>
                <div className='relative my-5 shadow-box-shadow rounded-2xl dashboard-banner'>
                    <img 
                        onClick={() => window.open("https://youtube.com/@earnipay?feature=shared", "_blank")} 
                        src={IconDashboardBannerDesktop} 
                        alt='dashboard icon banner' 
                        className='rounded-3xl dashboard-banner cursor-pointer' 
                    />
                    <button type="button" className="flex items-center justify-center transition duration-200 ease-in-out rounded-full banner-close-btn" onClick={handleCloseAdBanner}>
                        <CloseOutIcon />
                    </button>
                </div>
            </Maybe>
            
            <Maybe condition={isTablet && isAdBannerOpen}>
                <div className='relative my-5 shadow-box-shadow rounded-2xl dashboard-banner'>
                    <img 
                        onClick={() => window.open("https://youtube.com/@earnipay?feature=shared", "_blank")} 
                        src={IconDashboardBannerTablet} 
                        alt='dashboard icon banner' 
                        className='rounded-3xl cursor-pointer dashboard-banner' 
                    />
                    <button type="button" className="flex items-center justify-center transition duration-200 ease-in-out rounded-full banner-close-btn" onClick={handleCloseAdBanner}>
                        <CloseOutIcon />
                    </button>
                </div>
            </Maybe>
            
            <Maybe condition={isMobile && isAdBannerOpen}>
                <div className='relative my-5 shadow-box-shadow rounded-2xl dashboard-banner'>
                    <img 
                        onClick={() => window.open("https://youtube.com/@earnipay?feature=shared", "_blank")} 
                        src={IconDashboardBannerMobile} 
                        alt='dashboard icon banner' 
                        className='rounded-3xl cursor-pointer dashboard-banner' 
                    />
                    <button type="button" className="flex items-center justify-center transition duration-200 ease-in-out rounded-full banner-close-btn" onClick={handleCloseAdBanner}>
                        <CloseOutIcon />
                    </button>
                </div>
            </Maybe>

            <div className='my-5'>
                <div className='dashboard-row gap-6'>
                    <div className='w-full'>
                        <DashboardYield
                            YieldBalance={yieldBalance?.data?.balance}
                            loading={yieldBalanceLoading}
                        />
                        <InflowOutflow
                            cashFlow={dashboard?.inflowAndOutflow}
                            loading={dashboardLoading}
                            chartData={dashboard?.inflowAndOutflowGraphData}
                            handleSelectedInflowOutflowChange={handleSelectedInflowOutflowChange}
                            selectedInflowOutflowFilter={selectedInflowOutflowFilter}
                            filteringInflowOutflowData={filteringInflowOutflowData}
                        />
                    </div>
                    <div className='w-full'>
                        <OverallPieStats 
                            totalExpenceAmount={dashboard?.totalExpenceAmount} 
                            data={dashboard?.expencesChatData} handleSelectedExpensesChange={handleSelectedExpensesChange} selectedExpenseFilter={selectedExpenseFilter} 
                            filteringExpenseData={filteringExpenseData}
                        />
                    </div>
                </div>
            </div>

            <div>
                <div className='dashboard-row gap-6'>
                    <div className='w-full'>
                        <DashboardTransactions dashboard={dashboard} loading={dashboardLoading} />
                    </div>
                    <div className='w-full'>
                        <OnDemandPayStats odpData={dashboard?.employeeOdpStats} loading={dashboardLoading} />
                    </div>
                </div>
            </div>
        </div>
    )
}

const DashboardTransactions = ({ dashboard, loading }) => {
   return (
        <div className='bg-ep-white rounded-2xl my-5 p-5 h-full'>
            <div className='flex justify-between items-center mb-10'>
                <div className='font-bold text-xl text-ep-gray-300 '>Recent Transactions</div>
                {dashboard?.transactions?.length > 0 && <div>
                    <Link to="/payments/transaction-history" className="underline text-lg text-ep-primary-600 font-medium ">View all</Link>
                </div>}
            </div>
            <Maybe condition={loading}>
                <Spinner />
            </Maybe>

            <Maybe condition={!loading}>
                <div>
                    <Maybe condition={dashboard?.transactions?.length > 0}>
                        {/* Display only 5 transactions */}
                        {dashboard?.transactions?.slice(0,5).map((transaction, index) => (
                            <div key={index} className=''>
                                <div className='recent-transactions-container'>
                                    <div className='flex items-center'>
                                        <div className='mr-4'>{transaction.type === 'debit' ? <DebitIcon/> : <CreditIcon/>}</div>
                                        <div className='w-4/5'>
                                            <div className='text-base tracking-tight font-medium mb-1 text-ep-gray-700'>{transaction.description}</div>
                                            <div className='text-ep-gray-400 text-sm'>{DateTimeFormat(transaction.createdAt, 'lower')}</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='mb-1 whitespace-nowrap text-right text-ep-black text-base tracking-tight font-medium'>{transaction.type === 'debit' ? '- ' : '+ '}{CurrencyFormat(transaction.amount / 100, true)}</div>
                                        <div className={`text-sm rounded-3xl text-center py-1 px-2 capitalize font-medium ${transaction.status.toLowerCase() === 'successful' ? 'text-ep-success bg-ep-light-success' : 'bg-[#FFFAEB] text-[#B54708]'}`}>{transaction.status}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Maybe>

                    <Maybe condition={dashboard?.transactions?.length === 0}>
                        <div className="py-20 mx-auto text-center text-base">
                            <div className="flex justify-center">
                                <img src={IconEmptyBox} alt="Empty" className="h-48" />
                            </div>
                            <div className="text-[#101828] font-medium">
                                No Data Available Yet
                            </div>
                            <div className="mt-1 text-[#4A5564]">
                                Once you start transacting, it will appear here
                            </div>
                        </div>
                    </Maybe>
                </div>
            </Maybe>
        </div>
   )
}

const OnDemandPayStats = ({ loading, odpData }) => {
    return (
         <div className='bg-ep-white rounded-2xl my-5 p-5 h-full on-demand-chart-container'>
             <div className='mb-10'>
                 <div className='font-bold text-custom-xl'>Employees Using On-Demand Pay</div>
             </div>

             <Maybe condition={loading}>
                <Spinner />
            </Maybe>

            <Maybe condition={!loading}>
                <OnDemandPayEmployeesChart odpData={odpData} />
                <div className='flex space-x-4 my-5 justify-center'>
                    <div className='flex items-center'>
                        <div className="w-2 h-2 rounded-full mr-2" style={{backgroundColor: "#00535C"}}></div>
                        Enrolled
                    </div>
                    <div className='flex items-center'>
                        <div className="w-2 h-2 rounded-full mr-2" style={{backgroundColor: "#D6DADB"}}></div>
                        Not Enrolled
                    </div>
                </div>

                <div className='text-center mt-10 max-w-md mx-auto'>
                    <Link to="/invited-employees" className="inline-flex w-full justify-center border border-ep-primary-600 rounded-xl px-10 py-3 items-center text-ep-primary-600">
                        View Unenrolled Employees
                        <IconArrowRight className="ml-2"/>
                    </Link>
                </div>
            </Maybe>

             {/* <div> */}
                 {/* <Maybe condition={dashboard?.transactions?.length === 0}>
                     <div className="py-20 mx-auto text-center text-base">
                         <div className="flex justify-center">
                             <img src={IconEmptyBox} alt="Empty" className="h-48" />
                         </div>
                         <div className="text-[#101828] font-medium">
                             No Data Available Yet
                         </div>
                         <div className="mt-1 text-[#4A5564]">
                             Once you start transacting, it will appear here
                         </div>
                     </div>
                 </Maybe> */}
             {/* </div> */}
         </div>
    )
 }

const ComplianceNotification = () => {
    const history = useHistory();
    const {userInfo} = useLoginInfo();
    const {adminVerify, isCompliant, status, rejectComment} = userInfo.employer;
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
    
    const viewCompliance = () => {
        if (status === "pending"){
            history.push("/compliance");
        }
        else if (status === "review"){
            history.push("/compliance/registered/approval");
        }
        else if (status === "rejected"){
            setIsDetailsOpen(!isDetailsOpen);
        }
    }
    
    return (
        <>
            <Maybe condition={adminVerify === true && isCompliant === false}>
                <div className={`w-full mt-8 ${status !== "rejected" ? "bg-ep-primary-100":"bg-red-100"} overflow-auto rounded`}>
                    <div onClick={viewCompliance} className={`w-full px-6 py-4 ${status !== "rejected" ? "bg-ep-primary-100":"bg-red-100 hover:bg-red-200"} flex flex-wrap items-center justify-between rounded cursor-pointer`}>
                            
                        <div className="flex items-center">
                            <div className="w-5 mr-1">ℹ️</div>
                            <span className="mr-3 font-semibold hidden sm:inline">Notice:</span>&nbsp;
                            
                            <Maybe condition={status === "pending" || status === "approved"}>
                                Please fill your compliance information
                            </Maybe>
                            <Maybe condition={status === "review"}>
                                Your compliance information is being reviewed
                            </Maybe>
                            <Maybe condition={status === "rejected"}>
                                Sorry, your compliance information was not approved.
                            </Maybe>
                        </div>
                            
                        <div>
                            <div className={`inline-block border-b border-ep-primary ${status !== "rejected" ? "text-ep-primary border-ep-primary":"text-red-500 border-red-500"}`}>
                                <Maybe condition={status === "pending"}>
                                    <span className="hidden sm:inline">Start compliance</span>
                                </Maybe>
                                <Maybe condition={status === "rejected"}>
                                    <span className="hidden sm:inline">View details</span>
                                </Maybe>
                                
                                <span className="sm:hidden">
                                    <FontAwesomeIcon icon="angle-right" className="text-xl" />
                                </span>
                            </div>
                        </div>
                        
                    </div>
                    
                    <Maybe condition={isDetailsOpen === true}>
                        <div className="px-6 py-4">
                            <div>
                                {rejectComment?.slice(-1)[0]?.comment}
                            </div>
                            <div className="mt-2 mb-3">
                                <Link to="/compliance" className="btn btn-ep-primary">
                                    Make changes
                                </Link>
                            </div>
                        </div>
                    </Maybe>
                </div>
            </Maybe>
        </>
    )
}

const DashboardBanner = () => {
    const [showBanner, setShowBanner] = useState(true);

    const handleCloseBanner = () => {
        setShowBanner(false)
    }

    return (
        <Maybe condition={showBanner}>
            <div className='my-5 bg-ep-banner p-7 rounded-2xl relative'>
                <div className='flex flex-col lg:flex-row xl:flex-row lg:items-center xl:items-center gap-6'>
                    <div className='flex gap-6 items-center'>
                        <div><CashPayment className='w-20 h-20'/></div>
                        <div>
                            <div className='font-medium mb-2 text-ep-gray-300'>The New On-Demand Pay Module for Businesses</div>
                            <div className='text-ep-gray-600'>Supercharge your business and allow your employees request their wages anytime <br /> and anywhere, directly from their smartphones</div>
                        </div>
                    </div>
                    <div className='pl-10'>
                        <button type="button" className="btn btn-lg whitespace-nowrap text-white bg-ep-primary-600">
                            <BsPlayCircle className="mr-2 w-7 h-7" />
                            <span>Watch Video</span>
                        </button>
                    </div>
                </div>
                <div className='absolute right-0 top-0 mt-5 mr-5 cursor-pointer' onClick={handleCloseBanner}><CloseBanner/></div>
            </div>
        </Maybe>
    )
}

const DashboardYield = ({ YieldBalance, loading }) => {
    return (
        <div className='rounded-2xl bg-ep-white mb-5 p-5 flex justify-between items-center'>
             <div className='text-ep-gray-700'>
                <div className='mb-1 text-lg'>Yield earned this month</div>
                <div className='font-bold text-xl'>
                    <ContentLoading
                        loading={loading}
                        data={<>
                            {CurrencyFormat(YieldBalance / 100 || 0, true)}
                        </>}
                    />
                </div>
            </div>
            <div><IconYieldChart className='w-36 h-14'/></div>
        </div>
    )
}

const InflowOutflow = ({ cashFlow, chartData, handleSelectedInflowOutflowChange, selectedInflowOutflowFilter, filteringInflowOutflowData }) => {
    const { dashboardLoading } = useSelector((s) => s.entities.dashboard);

    return (
        <div className='rounded-2xl bg-ep-white p-5'>
            <div className='flex justify-between'>
                <div className='font-bold text-xl'>Inflow v. Outflow</div>
                <div>
                    <SelectInput onChange={handleSelectedInflowOutflowChange} value={selectedInflowOutflowFilter}>
                        <option value="" disabled>Select</option>
                        <option value="last6months">Last 6 Months</option>
                        <option value="last3months">Last 3 Months</option>
                        {/* <option value="monthly">Weekly</option> */}
                        <option value="weekly">Last 7 days</option>
                    </SelectInput>
                </div>
            </div>
            <hr className='mb-5'/>
            <div className='flex gap-6 text-ep-gray-300 mb-3 inflow-outflow-container'>
                <div className='lg:pr-6 lg:border-r lg:border-ep-gray-800'>
                    <div className='flex items-center'>
                        <span><IconInflow/></span>
                        <span className='ml-2 text-md text-ep-gray-600'>Inflow</span>
                    </div>
                    <Maybe condition={chartData?.length > 0}>
                        <div className='text-2xl font-medium inflow-outflow-amt'>{CurrencyFormat(cashFlow?.inflow / 100 || 0, true)}</div>
                    </Maybe>
                    <Maybe condition={chartData?.length === 0}>
                        <div className='text-2xl font-medium inflow-outflow-amt'>{CurrencyFormat(0, true)}</div>
                    </Maybe>
                </div>
                <div>
                    <div className='flex items-center'>
                        <span><IconOutflow/></span>
                        <span className='ml-2 text-md text-ep-gray-600'>Outflow</span>
                    </div>
                    <Maybe condition={chartData?.length > 0}>
                        <div className='text-2xl font-medium inflow-outflow-amt'>{CurrencyFormat(cashFlow?.outflow / 100 || 0, true)}</div>
                    </Maybe>
                    <Maybe condition={chartData?.length === 0}>
                        <div className='text-2xl font-medium inflow-outflow-amt'>{CurrencyFormat(0, true)}</div>
                    </Maybe>
                </div>
            </div>

            <div>
                <InflowOutflowChart
                    loading={filteringInflowOutflowData}
                    // loading={dashboardLoading}
                    chartData={chartData}
                    selectedInflowOutflowFilter={selectedInflowOutflowFilter}
                />
            </div>
        </div>
    )
}

const OverallPieStats = ({ totalExpenceAmount, data, handleSelectedExpensesChange, selectedExpenseFilter, filteringExpenseData }) => {
    const { dashboardLoading } = useSelector((s) => s.entities.dashboard);

    const firstThree = data?.length > 0 && data?.slice(0, 3);
    const otherThree = data?.length > 0 && data?.slice(3, 6);
    const colors = data?.length > 0 && data?.map(item => item?.color);

    return (
        <div className='bg-ep-white p-5 rounded-2xl h-full'>
            <div className='flex justify-between mb-5'>
                <div className='font-bold text-xl'>Expense breakdown</div>
                <div>
                    <SelectInput onChange={handleSelectedExpensesChange} value={selectedExpenseFilter}>
                        <option value="" disabled>Select</option>
                        <option value="last6months">Last 6 Months</option>
                        <option value="last3months">Last 3 Months</option>
                        <option value="monthly">Month-to-date</option>
                        <option value="weekly">Last 7 days</option>
                    </SelectInput>
                </div>
            </div>
            <div className='mb-5'>
                <HowYouSpentChart /* loading={dashboardLoading} */ loading={filteringExpenseData} data={data} totalExpenceAmount={totalExpenceAmount} colors={colors}/>
            </div>
            <Maybe condition={data?.length > 0}>
                <div className='flex gap-6'>
                    <div>
                        {firstThree.length > 0 && firstThree?.map((el, index) => (
                            <div key={index} className='flex items-center text-sm my-3'>
                                <div className="w-2 h-2 rounded-full mr-2" style={{backgroundColor: el?.color}}></div>
                                <div className='text-ep-gray-600'>{el?.name} <span className='text-ep-gray-300 font-medium'>{el?.percentage}%</span></div>
                            </div>
                        ))}
                    </div>
                    <div>
                        {otherThree.length > 0 && otherThree?.map((el, index) => (
                            <div key={index} className='flex items-center text-sm my-3'>
                                <div className="w-2 h-2 rounded-full mr-2" style={{backgroundColor: el?.color}}></div>
                                <div className='text-ep-gray-600'>{el?.name} <span className='text-ep-gray-300 font-medium'>{el?.percentage}%</span></div>
                            </div>
                        ))}
                    </div>
                </div>
            </Maybe>
        </div>
    )
}

export default Dashboard;